import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import CompanyOverview from "./sections/CompanyOverview";
import CoreValues from "./sections/CoreValues";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <CompanyOverview />
      <CoreValues />
      <Footer />
    </div>;
}